import Grid from '@mui/material/Grid'

import GridItem from '@ecm/ui/element/GridItem'

type HowItWorksGridBlockProps = Pick<React.ComponentProps<typeof GridItem>, 'alignCenter'>

const HowItWorksGridBlock = ({ alignCenter }: HowItWorksGridBlockProps) => (
  <Grid
    container
    justifyContent={alignCenter ? 'center' : undefined}
    /* eslint-disable sort-keys */
    spacing={{
      xs: 4,
      md: 8,
    }}
    /* eslint-disable sort-keys */
  >
    <Grid item md={4}>
      <GridItem heading="We receive your mail" icon="logomark" alignCenter={alignCenter}>
        Your postal mail is sent to a virtual address and processed at our secure facilities
      </GridItem>
    </Grid>

    <Grid item md={4}>
      <GridItem heading="We digitize it for you" icon="secure-delivery" alignCenter={alignCenter}>
        Your mail is scanned and delivered into your inbox as a high-resolution PDF
      </GridItem>
    </Grid>

    <Grid item md={4}>
      <GridItem heading="You take control" icon="document" alignCenter={alignCenter}>
        You access your postal mail and deposit checks online
      </GridItem>
    </Grid>
  </Grid>
)

export default HowItWorksGridBlock
